import { EmptyProps } from '@core/components/empty/empty.component';
import { PaymentHistoryData } from '@shared/payment-history/payment-history.component';
import { CurrencyEnum } from 'lingo2-models';

export const emptyTeachingObj: Partial<EmptyProps> = {
  text: 'user-profile.placeholder.teaching.text',
  link: '/profile/teaching',
  link2: '/profile/teaching',
  link_label: 'user-profile.placeholder.about.link',
  image: 'subjects',
};

export const emptyAboutObj: Partial<EmptyProps> = {
  text: 'user-profile.placeholder.about.text',
  link: '/profile/about',
  link_auth: true,
  link2: '/profile/about',
  link_label: 'user-profile.placeholder.about.link',
  image: 'about-tutor',
};

export const emptyEducationObj: Partial<EmptyProps> = {
  text: 'user-profile.placeholder.about.text',
  link: '/profile/education',
  link2: '/profile/education',
  link_label: 'user-profile.placeholder.about.link',
  image: 'education',
};

export const emptyExperienceObj: Partial<EmptyProps> = {
  text: 'user-profile.placeholder.about.text',
  link: '/profile/experience',
  link2: '/profile/experience',
  link_label: 'user-profile.placeholder.about.link',
  image: 'experience',
};

export const emptyClassesObj: Partial<EmptyProps> = {
  text: 'user-profile.placeholder.Classes.text',
  link: '/my-library/services',
  link2: '/my-library/services',
  link_label: 'user-profile.placeholder.Classes.link',
  image: 'classes',
};

export const emptyCollectionObj: Partial<EmptyProps> = {
  text: 'user-profile.placeholder.collection.text',
  link: '/my-library/collections',
  link2: '/my-library/collections',
  link_label: 'user-profile.placeholder.collection.link',
  image: 'collections',
};

export const emptyFeedbackObj: Partial<EmptyProps> = {
  text: 'user-profile.placeholder.feedback.text',
  link: '/my-library/services',
  link2: '/my-library/services',
  link_label: 'user-profile.placeholder.feedback.link',
  image: 'comments',
};

export const emptyLessonObj: Partial<EmptyProps> = {
  text: 'user-profile.placeholder.lesson.text',
  link: '/my-library/lessons',
  link2: '/my-library/lessons',
  link_label: 'user-profile.placeholder.lesson.link',
  image: 'lessons',
};

export const emptySchoolObj: Partial<EmptyProps> = {
  text: 'user-profile.placeholder.school.text',
  link: '/schools',
  link2: '/schools',
  link_label: 'user-profile.placeholder.school.link',
  image: 'schools',
};

export const paymentsHistory: PaymentHistoryData[] = [
  {
    id: 'id1',
    date: new Date(),
    operationTitle: 'Покупка тарифа',
    operationDesc:
      'How a visual artist redefines success in graphic design How a visual artist redefines success in graphic design How a visual artist redefines success in graphic design',
    amount: 99,
    currency: CurrencyEnum.usd,
    operationType: 'credit',
    status: 'completed',
  },
  {
    id: 'id2',
    date: new Date(),
    operationTitle: 'Покупка урока',
    operationDesc: 'How a visual artist redefines success in graphic design',
    amount: 999,
    currency: CurrencyEnum.eur,
    operationType: 'credit',
    status: 'pending',
  },
  {
    id: 'id3',
    date: new Date(),
    operationTitle: 'Продажа урока',
    operationDesc: 'How a visual artist redefines success in graphic design',
    amount: 104,
    currency: CurrencyEnum.usd,
    operationType: 'debit',
    status: 'completed',
  },
  {
    id: 'id1',
    date: new Date(),
    operationTitle: 'Покупка тарифа',
    operationDesc: 'How a visual artist redefines success in graphic design',
    amount: 99,
    currency: CurrencyEnum.usd,
    operationType: 'credit',
    status: 'completed',
  },
  {
    id: 'id2',
    date: new Date(),
    operationTitle: 'Покупка урока',
    operationDesc: 'How a visual artist redefines success in graphic design',
    amount: 999,
    currency: CurrencyEnum.eur,
    operationType: 'credit',
    status: 'pending',
  },
  {
    id: 'id3',
    date: new Date(),
    operationTitle: 'Продажа урока',
    operationDesc: 'How a visual artist redefines success in graphic design',
    amount: 104,
    currency: CurrencyEnum.usd,
    operationType: 'debit',
    status: 'completed',
  },
  {
    id: 'id4',
    date: new Date(),
    operationTitle: 'Продажа урока',
    operationDesc: 'How a visual artist redefines success in graphic design',
    amount: 112,
    currency: CurrencyEnum.eur,
    operationType: 'debit',
    status: 'canceled',
  },
  {
    id: 'id2',
    date: new Date(),
    operationTitle: 'Покупка урока',
    operationDesc: 'How a visual artist redefines success in graphic design',
    amount: 999,
    currency: CurrencyEnum.eur,
    operationType: 'credit',
    status: 'pending',
  },
  {
    id: 'id3',
    date: new Date(),
    operationTitle: 'Продажа урока',
    operationDesc: 'How a visual artist redefines success in graphic design',
    amount: 104,
    currency: CurrencyEnum.usd,
    operationType: 'debit',
    status: 'completed',
  },
  {
    id: 'id4',
    date: new Date(),
    operationTitle: 'Продажа урока',
    operationDesc: 'How a visual artist redefines success in graphic design',
    amount: 112,
    currency: CurrencyEnum.eur,
    operationType: 'debit',
    status: 'canceled',
  },
  {
    id: 'id2',
    date: new Date(),
    operationTitle: 'Покупка урока',
    operationDesc: 'How a visual artist redefines success in graphic design',
    amount: 999,
    currency: CurrencyEnum.eur,
    operationType: 'credit',
    status: 'pending',
  },
  {
    id: 'id3',
    date: new Date(),
    operationTitle: 'Продажа урока',
    operationDesc: 'How a visual artist redefines success in graphic design',
    amount: 104,
    currency: CurrencyEnum.usd,
    operationType: 'debit',
    status: 'completed',
  },
  {
    id: 'id4',
    date: new Date(),
    operationTitle: 'Продажа урока',
    operationDesc: 'How a visual artist redefines success in graphic design',
    amount: 112,
    currency: CurrencyEnum.eur,
    operationType: 'debit',
    status: 'canceled',
  },
];
